import React from "react";
import { Form, Button, Modal, Dropdown } from "semantic-ui-react";
import { useFormik } from "formik";
import { determineFuelsUnits } from "../../../../utils/dataAndFormulas/fuelsForms";
import { fuelsCodes } from "../../../../utils/dataAndFormulas/fuelsForms";
import { useLanguage } from "../../../../contexts";
import "./UnitsForm.scss";

export function UnitsForm(props) {
  const { show, onClose, onSave, currentUnits, registeredFields } = props;
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  // Lista de todos los campos de combustibles por defecto
  const allFuelsFields = [
    { key: "natural_gas", label: t("natural_gas") },
    { key: "natural_gas_cost", label: t("natural_gas_cost") },
    { key: "glp", label: t("glp") },
    { key: "glp_cost", label: t("glp_cost") },
    { key: "diesel", label: t("diesel") },
    { key: "diesel_cost", label: t("diesel_cost") },
    { key: "biodiesel", label: t("biodiesel") },
    { key: "cost_biodiesel", label: t("cost_biodiesel") },
    { key: "gasoline", label: t("gasoline") },
    { key: "gasoline_cost", label: t("gasoline_cost") },
    { key: "ethanol", label: t("ethanol") },
    { key: "ethanol_cost", label: t("ethanol_cost") },
    { key: "electricity_vehicles", label: t("electricity_vehicles") },
    { key: "cost_electricity_vehicles", label: t("cost_electricity_vehicles") },
    { key: "natural_gas_vehicles", label: t("natural_gas_vehicles") },
    { key: "glp_vehicles", label: t("glp_vehicles") },
    { key: "diesel_vehicles", label: t("diesel_vehicles") },
    { key: "biodiesel_vehicles", label: t("biodiesel_vehicles") },
    { key: "gasoline_vehicles", label: t("gasoline_vehicles") },
    { key: "ethanol_vehicles", label: t("ethanol_vehicles") },
    { key: "electric_vehicles", label: t("electric_vehicles") },
  ];

  // Si hay registeredFields con datos, usar solo los campos activos
  // Si no hay registeredFields o está vacío, usar todos los campos por defecto
  const fuelsFields =
    registeredFields && registeredFields.length > 0
      ? registeredFields
          .filter((field) => field.active !== false) // Solo campos activos
          .map((field) => ({
            key: field.name,
            label: t(field.name),
            code: field.code,
          }))
      : allFuelsFields;

  const formik = useFormik({
    initialValues: fuelsFields.reduce((acc, field) => {
      acc[field.key] = currentUnits?.[field.key] || "";
      return acc;
    }, {}),
    enableReinitialize: true,
    onSubmit: (values) => {
      onSave(values);
      onClose();
    },
  });

  return (
    <Modal
      open={show}
      onClose={onClose}
      size="large"
      className="units-form-modal"
    >
      <Modal.Content>
        <Form onSubmit={formik.handleSubmit}>
          <div className="units-form-modal__title">{t("configure_units")}</div>
          <div className="units-grid">
            {fuelsFields.map((field) => (
              <div key={field.key} className="unit-row">
                <span className="unit-label">{field.label}</span>
                <Dropdown
                  placeholder={t("select_unit")}
                  selection
                  search
                  clearable
                  options={determineFuelsUnits(field.key).map((unit) => ({
                    key: unit.key,
                    text: t(unit.name),
                    value: unit.value,
                  }))}
                  value={formik.values[field.key]}
                  onChange={(_, data) =>
                    formik.setFieldValue(field.key, data.value)
                  }
                />
              </div>
            ))}
          </div>
        </Form>
      </Modal.Content>
      <Modal.Actions style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
        <Button primary onClick={formik.handleSubmit}>
          {t("save")}
        </Button>
        <Button onClick={onClose} className="units-btn-cancel">
          {t("cancel")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
